import { css } from '@emotion/core';

export default ({ bodyMaxHeight, isCollapsed, isScrollable, isFooterInsideCard }) => ({
  cardWrapperStyles: ({ classes, cybs }) => css`
    ${classes?.skin?.bg?.misc?.white ?? 'background-color: #ffffff;'};
    border-radius: 4px;
    border: 1px solid ${cybs?.base?.wcag21?.stoneGrey?? '#62798D'};
    width: 100%;
    p, h3{
      color: ${cybs?.base?.wcag21?.charcoal ?? "#000000"}
    }
    ${isFooterInsideCard
      ? `
       & .cybs-form-footer {
        border-left: none;
        border-bottom: none;
        border-right: none;
        border-top: 0.1px solid ${cybs?.base?.wcag21?.stoneGrey ?? '#62798D'};
         
       }
      `
      : ''}
  `,
  cardBodyStyles: ({ classes }) => css`
    ${classes?.structure?.padding?.space?.all[2] ?? 'padding: 1.0rem;'};
    ${isScrollable
      ? `
        max-height: ${bodyMaxHeight}px;
        overflow: auto;
      `
      : ''}
    ${isCollapsed
      ? `
        &,
        & + div {
          height: 0;
          padding: 0;
          visibility: hidden;
          overflow: hidden;
        }
      `
      : ''}
    box-sizing: border-box;

    &[tabindex]:not([tabindex='-1']):focus,
    & [tabindex]:not([tabindex='-1']):focus {
      outline: 1px dashed;
      ${classes?.skin?.outline?.element?.dark ?? 'outline-color: #000000;'};
    }
  `
});
